export const backendUrl = process.env.REACT_APP_backendUrl;
export const enrollFrontUrl = process.env.REACT_APP_enrollFrontUrl;
export const backendFormUrl = process.env.REACT_APP_backendFormUrl;
export const formLocation = process.env.REACT_APP_formLocation;
export const workShopLocation = process.env.REACT_APP_workShopLocation;
export const frontLocation = process.env.REACT_APP_frontLocation;
